import React, { useState } from 'react';
import SignupForm from './SignupForm';
import ProfileForm from './ProfileForm';
import { User } from '../types';

interface SignupModalProps {
  isOpen: boolean;
  onClose?: () => void;
  jobListingId?: string;
  actionType?: string;
}

const SignupModal: React.FC<SignupModalProps> = ({ 
  isOpen, 
  onClose = () => {}, 
  jobListingId, 
  actionType 
}) => {
  const [step, setStep] = useState<'signup' | 'profile'>('signup');
  const [user, setUser] = useState<User | null>(null);

  const handleSignupSuccess = (userData: User) => {
    setUser(userData);
    setStep('profile');
  };

  const handleProfileComplete = () => {
    onClose();
    if (jobListingId) {
      if (actionType === 'apply') {
        window.location.href = `/job_listings/${jobListingId}`;
      } else {
        window.location.href = `/job_listings/${jobListingId}`;
      }
    } else {
      window.location.href = '/';
    }
  };

  const handleClose = () => {
    setStep('signup');
    setUser(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {step === 'signup' ? '無料登録' : 'プロフィール登録'}
            </h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={handleClose}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            {step === 'signup' && (
              <SignupForm 
                onSuccess={handleSignupSuccess}
                jobListingId={jobListingId}
                actionType={actionType}
              />
            )}
            {step === 'profile' && user && (
              <ProfileForm 
                user={user}
                onComplete={handleProfileComplete}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupModal;
